import React from 'react'
import { Redirect, Router, Switch, HashRouter } from 'react-router-dom'
import Route from './route-wrapper';
import Path from './routes-path';
import history from './history';
import Layout from '../../../layout/layout'
import School from '../school/school'
import ChangePassword from '../change-password/change-password';
import HomeComponent from '../home-component/home-component';
import ConfirmProfile from '../confirm-profile/confirm-profile';
import SchoolSignupComponent from '../school-signup-component/school-signup-component-v2';
import RMSSignupComponent from '../school-signup-component/rms-signup/school-signup-component';
import CSFSignupComponent from '../school-signup-component/csf-signup/school-signup-component';

import MPLSignupComponent from '../school-signup-component/mpl-singup/school-signup-component';
import FLCSignupComponent from '../school-signup-component/flc-singup/school-signup-component';
import MSFSignupComponent from '../school-signup-component/msf-signup/school-signup-component';
import CMOSignupComponent from '../school-signup-component/cmo-signup/school-signup-component';
import NMDSignupComponent from '../school-signup-component/nmd-signup/school-signup-component';
import FFLSignupComponent from '../ffl-signup/ffl-signup';

import SchoolSelect from '../super-admin/school-select/school-select';
import ONBOARDING from '../onboarding/onboarding';
import FORGOT_PASSWORD from '../forgot-password/forgot-password';
import SchoolUsersSignupLayout from '../school-users-signup/school-users-signup-layout';
import MOENGAGE from '../moengage/moengage';
import HomeworkAssign from '../homework-assign/homework-assign';
import ClaimForm from '../claim-form/claim-form';
import MMSClaimForm from '../claim-form/mms/claim-form';
import HomeworkV2 from '../homework-link/new-homework';
import InvitationSuccess from '../whatsapp/success/success';
import MMSJune2022ClaimForm from '../claim-form/mms-june-2022/claim-form';
import MPL2022ClaimForm from '../claim-form/mpl-2022/claim-form';
import HomeworkNotification from '../homework/notification/notification';
import FLCClaimForm from '../claim-form/flc/claim-form';
// import CompletionReport from '../homework/completion-report/completion-report';
// import HomeworkEvalutionReport from '../homework/reports/evaluation-report/evaluation-report';
// import WrongAnswersReport from '../common/wrong-answers-modal/wrong-answers-modalV1/wrong-answers-modal';
// import ELOLevelReport from '../homework/reports/elo-report/elo-reportV1/elo-report'

// import AssessmentTestResultsReport from '../tests-v2/reports/test-results/test-results'
// import TestCompletionReport from '../tests-v2/reports/completion-report/completion-report'
// import TestWrongAnswerReport from '../common/wrong-answers-modal/wrong-answers-modalV1/wrong-answers-modal'
// import TestAllQuestionsReport from '../tests-v2/reports/all-questions/all-questions'
import PublicComponent from '../class-work/recommandation-report/public-component/public-component';


export default function Routes() {

  return (
    <Router history={history}>
      <Switch>
      {/* <Route  exact path={ `${Path.HOMEWORK_COMPLETION_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`} component={CompletionReport} />
      <Route  exact path={ `${Path.HOMEWORK_EVALUATION_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`} component={HomeworkEvalutionReport} />
      <Route  exact path={ `${Path.MOST_WRONG_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`} component={WrongAnswersReport} />
      <Route  exact path={ `${Path.ELO_LEVEL_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`} component={ELOLevelReport} />

      <Route  exact path={ `${Path.ASSESSMENT_RESULTS_REPORT}:homeworkId/:chapter/:class/:createdDate/:schoolName/:teacherName/:city/:branch`} component={AssessmentTestResultsReport} />
      <Route  exact path={ `${Path.TEST_COMPLETION_REPORT}:homeworkId/:chapter/:class/:createdDate`} component={TestCompletionReport} />
      <Route  exact path={ `${Path.TEST_WRONG_ANSWER_REPORT}:type/:homeworkId/:chapter/:class/:createdDate`} component={TestWrongAnswerReport} />
      <Route  exact path={ `${Path.TEST_ALL_QUESTIONS_REPORT}:homeworkId/:chapter/:class/:createdDate`} component={TestAllQuestionsReport} /> */}

        <Route exact path={Path.VERIFY} component={School} />
        <Route exact path={Path.UPDATE_PASSWORD} component={ChangePassword} />
        <Route exact path={Path.CONFIRM_PROFILE} component={ConfirmProfile} />
        <Route exact path={Path.LOGIN} component={HomeComponent} />
        <Route exact path={Path.HOME} component={Layout} />
        <Route exact path={Path.USERS_SIGNUP} component={SchoolUsersSignupLayout} />
        <Route exact path={Path.SIGNUP} component={SchoolSignupComponent} />
        <Route exact path={Path.RMS_SIGNUP} component={RMSSignupComponent} />
        <Route exact path={Path.CSF_SIGNUP} component={CSFSignupComponent} />
        <Route exact path={Path.MPL_SIGNUP} component={MPLSignupComponent} />
        <Route exact path={Path.FLC_SIGNUP} component={FLCSignupComponent} />
        <Route exact path={Path.MSF_SIGNUP} component={MSFSignupComponent} />
        <Route exact path={Path.PUBLIC_COMPONENT} component={PublicComponent} />
        <Route exact path={Path.CMO_SIGNUP} component={CMOSignupComponent} />
        <Route exact path={Path.NMD_SIGNUP} component={NMDSignupComponent} />
        <Route exact path={Path.FFL_SIGNUP} component={FFLSignupComponent} />
        <Route exact path={Path.ONBOARD} component={ONBOARDING} />
        <Route exact path={Path.SCHOOLS} component={SchoolSelect} />
        <Route exact path={Path.FORGOT_PASSWORD} component={FORGOT_PASSWORD} />
        <Route exact path={Path.PAT_NOTIFICATION} component={MOENGAGE} />
        <Route exact path={Path.PARENT_PAT_NOTIFICATION} component={MOENGAGE} />
        <Route exact path={Path.HOMEWORK_NOTIFICATION} component={HomeworkNotification} />
        <Route exact path={Path.HOMEWORK_ASSIGN} component={HomeworkAssign} />
        <Route exact path={Path.HOMEWORK_ASSIGN_V2} component={HomeworkAssign} />
        <Route exact path={Path.CLAIM_FORM} component={ClaimForm} />
        <Route exact path={Path.MMS_CLAIM_FORM} component={MMSClaimForm} />
        <Route exact path={Path.MPL_2022_CLAIM_FORM} component={MPL2022ClaimForm} />
        <Route exact path={Path.MMS_JUNE_22_CLAIM_FORM} component={MMSJune2022ClaimForm} />
        <Route exact path={Path.FLC_CLAIM_FORM} component={FLCClaimForm} />
        <Route exact path={Path.HOMEWORK_V2} component={HomeworkV2} />
        <Route exact path={Path.INVITATION_SUCCESS} component={InvitationSuccess} />
        <Route exact path="*" component={Layout} />
      </Switch>
    </Router>
  )
}
